import React from "react";
import useDocumentTitle from "@/components/ui/common/document-title";
import ForeeReportTable from "./table";

export default function ForeeReport() {
  useDocumentTitle("Foree Report");

  return (
    <div className="w-full p-5 space-y-6">
      <div className="space-y-6">
        <ForeeReportTable />
      </div>
    </div>
  );
}
